import React from 'react';
import styled from '@emotion/styled';

import { Icon } from '../lumen';
import { Dropdown } from './Dropdown';
import logoCemantica from './assets/logo-cemantica.svg';

export const AppHeader = ({
  userInitials = 'U',
  onSettings,
  onLogout
}) => {
  return (
    <Root>
      <LogoWrap>
        <LogoImg src={logoCemantica} alt="Cemantica" />
        <LogoSubtitle>Insights hub</LogoSubtitle>
      </LogoWrap>
      <Right>
        <Dropdown
          align="right"
          trigger={
            <AvatarTrigger type="button">
              <Avatar>{userInitials}</Avatar>
              <Icon name="chevDown" size={14} />
            </AvatarTrigger>
          }
        >
          <MenuItem onClick={onSettings}>Settings</MenuItem>
          <MenuItem onClick={onLogout}>Log out</MenuItem>
        </Dropdown>
      </Right>
    </Root>
  );
};

const Root = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: ${({ theme }) => theme.color.bg.default};
  border-bottom: 1px solid #f0f0f0;
  height: 50px;
  flex-shrink: 0;
`;

const LogoWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

const LogoImg = styled.img`
  width: 128px;
  height: 17px;
  display: block;
  flex-shrink: 0;
`;

const LogoSubtitle = styled.span`
  font-family: 'Andika New Basic', Georgia, serif;
  font-style: italic;
  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.color.slate[600]};
  margin-left: 26px;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const AvatarTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
`;

const Avatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: ${({ theme }) => theme.color.fg.default};
  color: ${({ theme }) => theme.color.bg.default};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
`;

const MenuItem = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.fg.default};
  background: transparent;
  border: 0;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.bg.subtle};
  }
`;
